import { Component, Injector, ViewChild } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { FileUpload, FileUploadHandlerEvent } from 'primeng/fileupload';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { finalize } from 'rxjs';
import { HelpCenterService } from '../../../service/help-center.service';
import { HelpCenterDocBean } from '../model/HelpCenterDocBean';

@Component({
  selector: 'help-center-file-edit',
  templateUrl: './help-center-file-edit.component.html',
  styleUrls: ['./help-center-file-edit.component.scss'],
})
export class HelpCenterFileEditComponent extends SessionBaseComponent {
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  permissionCode: string = this.config.data.permissionCode;
  fileType: string = this.config.data.fileType;
  editPermision: boolean = this.config.data.editPermision;

  constructor(
    injector: Injector,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private helpCenterService: HelpCenterService,
  ) {
    super(injector);
  }


  // columns def
  docColumns = [
    { field: 'name', header: 'HelpCenter.Document.Name', sort: true, width: 325 },
    { field: 'fileSize', header: 'HelpCenter.Document.FileSize', sort: true, width: 325 },
    { field: 'updateUser', header: 'HelpCenter.Document.UpdateUser', sort: true, width: 325 },
    { field: 'updateDt', header: 'HelpCenter.Document.UpdateDt', sort: true, width: 325 },
    { field: 'downloadBtn', header: 'HelpCenter.Document.Download', width: 70, headerStyle: 'text-align: center;' },
    { field: 'deleteBtn', header: 'HelpCenter.Document.Delete', width: 70, headerStyle: 'text-align: center;' },
  ];

  dialogLoading: boolean = false;

  docs: HelpCenterDocBean[] = [];

  async ngOnInit(): Promise<void> {
    this.searchFiles();
  }

  fileUploader(event: FileUploadHandlerEvent): void {
    this.dialogLoading = true;
    // 上傳時傳入當前選擇的 category
    this.helpCenterService.uploadGuideDoc(
      event.files[0],
      this.permissionCode,
      event.files[0].name,
      this.fileType
    )
    .pipe(finalize(() => {this.dialogLoading = false;}))
    .subscribe({
      next: () => {
        this.toastService.success(this.translateService.instant('PlantTransfer.Message.UploadSuccess'));
        this.fileUpload.clear();
        this.searchFiles();
      },
      error: (resp) => {
        if (resp.error) {
          this.toastErrorMessage(resp.error);
        }
      },
    });
  }

  searchFiles(): void {
    this.dialogLoading = true;
    // 查詢時傳入當前選擇的 category
    this.helpCenterService.getGuideDocList(this.permissionCode,this.laasSetting.language, this.fileType)
    .pipe(finalize(() => {this.dialogLoading = false;}))
    .subscribe({
      next: (docs) => {
        this.docs = docs;
      },
      error: (resp) => {
        if (resp.error) {
          this.toastErrorMessage(resp.error);
        }
      },
    });
  }

  downloadDoc($event: any, row: any): void {
    this.dialogLoading = true;
    this.helpCenterService.downloadDoc(row.sn)
    .pipe(finalize(() => {this.dialogLoading = false;}))
    .subscribe({
      next: (file) => {
        const url = URL.createObjectURL(file);
        const a: any = document.createElement('a');
        a.href = url;
        a.download = row.name?? '';
        a.click();
        URL.revokeObjectURL(url);
      },
      error: (resp) => {
        if (resp.error) {
          this.toastErrorMessage(resp.error);
        }
      },
    });
  }

  deleteDoc($event: any, row: any): void {
    this.dialogLoading = true;
    this.helpCenterService.deleteDoc(row.sn)
    .pipe(finalize(() => {this.dialogLoading = false;}))
    .subscribe({
      next: () => {
        this.toastService.success(this.translateService.instant('HelpCenter.Message.DeleteSuccess'));
        this.searchFiles();
      },
      error: (resp) => {
        if (resp.error) {
          this.toastErrorMessage(resp.error);
        }
      },
    });
  }

  // 新增：切換分頁時重新查詢
  onTabChange(): void {
    this.searchFiles();
  }

}
